<app-screen-shell
  [contentClass]="'container player-profile-page footballer-friends-page football-references-page'"
  titleKey="players.footballReferences"
  [subtitle]="playerName"
  [loading]="isContentLoading()"
  loadingTitleKey="players.footballReferencesLoading"
  [hideContentWhileLoading]="true"
  (back)="goBack()">

  @if (!isContentLoading() && (!loading || references.length > 0)) {
  <section class="footballer-friends-toolbar profile-content-width player-detail-content-width">
    <label class="sr-only" for="footballReferencesSearch">{{ 'players.searchReferences' | translate }}</label>
    <div class="footballer-friends-search">
      <i [class]="'common.search' | nogoshIcon" aria-hidden="true"></i>
      <input
        id="footballReferencesSearch"
        type="search"
        [value]="searchQuery"
        [placeholder]="'players.searchReferences' | translate"
        (input)="onSearch($any($event.target).value)">
      @if (searchQuery) {
        <button type="button" (click)="clearSearch()" [title]="'common.clear' | translate" [attr.aria-label]="'common.clear' | translate">
          <i [class]="'common.close' | nogoshIcon" aria-hidden="true"></i>
        </button>
      }
    </div>
    <div class="footballer-friends-total">
      <span>{{ total }}</span>
      <strong>{{ 'players.footballReferencesTotal' | translate }}</strong>
    </div>
  </section>
  }

  @if (!isContentLoading() && errorMsg) {
    <section class="public-player-profile-state">
      <i [class]="'match.inviteFriends' | nogoshIcon" aria-hidden="true"></i>
      <h1>{{ 'common.error' | translate }}</h1>
      <p>{{ errorMsg }}</p>
    </section>
  }

  @if (!isContentLoading() && !errorMsg && references.length > 0) {
    <section class="footballer-friends-list profile-content-width player-detail-content-width" [attr.aria-label]="'players.footballReferences' | translate">
      @for (reference of references; track reference.playerId) {
        <article class="footballer-friend-card">
          <div class="footballer-friend-main football-reference-main">
            <button
              type="button"
              class="football-reference-profile-button"
              [disabled]="!reference.openProfile"
              (click)="openReferenceProfile(reference)"
              [title]="profileTitle(reference)"
              [attr.aria-label]="profileTitle(reference)">
              <span class="footballer-friend-avatar">
                @if (reference.avatar) {
                  <img [src]="reference.avatar" [alt]="displayName(reference)" onerror="this.style.display='none'">
                } @else {
                  <span>{{ initials(reference) }}</span>
                }
              </span>
              <span class="footballer-friend-copy">
                <strong>{{ displayName(reference) }}</strong>
                @if (reference.city) {
                  <span>{{ reference.city }}</span>
                }
              </span>
            </button>
            <button type="button" class="football-reference-profile-icon-button" [disabled]="!reference.openProfile" (click)="openReferenceProfile(reference)" [title]="profileTitle(reference)" [attr.aria-label]="profileTitle(reference)">
              <i [class]="'player.profile' | nogoshIcon" aria-hidden="true"></i>
            </button>
          </div>

          <div class="footballer-friend-stats football-reference-stats">
            <div>
              <span>{{ 'players.referenceScore' | translate }}</span>
              <strong>{{ reference.referenceScore || 0 }}</strong>
            </div>
            <div>
              <span>{{ 'players.youWithReference' | translate }}</span>
              <strong>{{ reference.currentSharedMatchCount || 0 }}</strong>
            </div>
            <div>
              <span>{{ 'players.referenceWithPlayer' | translate }}</span>
              <strong>{{ reference.viewedSharedMatchCount || 0 }}</strong>
            </div>
            <div>
              <span>{{ 'players.sameMatchTogether' | translate }}</span>
              <strong>{{ reference.sameMatchTogetherCount || 0 }}</strong>
            </div>
            <div>
              <span>{{ 'players.lastReferenceMatch' | translate }}</span>
              <strong>{{ dateLabel(reference.lastPlayedWithViewedAt) }}</strong>
            </div>
          </div>
        </article>
      }
    </section>
  }

  @if (!isContentLoading() && !loading && !errorMsg && references.length === 0) {
    <section class="public-player-profile-state">
      <i [class]="'match.inviteFriends' | nogoshIcon" aria-hidden="true"></i>
      <h1>{{ 'players.footballReferencesEmptyTitle' | translate }}</h1>
      <p>{{ searchQuery ? ('players.footballReferencesSearchEmpty' | translate) : ('players.footballReferencesEmpty' | translate) }}</p>
    </section>
  }

  @if (!isContentLoading() && !errorMsg && hasMore) {
    <div class="event-history-load-more">
      <button type="button" class="btn btn-secondary btn-sm px-3 text-white" [disabled]="loading" (click)="loadMore()">{{ 'common.more' | translate }}</button>
    </div>
  }
</app-screen-shell>
